import React, { useState, useEffect } from 'react';
import { subscribeToast } from '../services/toast';

interface ToastItem {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info';
}

export default function Toast() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const unsub = subscribeToast(setToasts);
    return unsub;
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.type === 'error' ? 'error' : t.type === 'info' ? 'info' : ''}`}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
